export default{
  addresses: (state) => state.addresses,
  address: (state) => state.address
}



// WEBPACK FOOTER //
// ./src/components/address/store/getters.js